import React, { useState } from "react";
import Button from "../buttons/button";

import { Nav, Tab } from "react-bootstrap";
import { Filtersvg } from "../../../svgFiles/Filtersvg";
import Dropdown from "react-bootstrap/Dropdown";
import FilterComponent from "../fields/FilterComponent";
import EmployeeFilter from "../fields/EmployeeFilter";
import StaffAttendanceFilter from "../fields/StaffAttendanceFilter";
import StaffAttendanceReportFilter from "../fields/StaffAttendanceReportFilter";
import BillListingFilter from "../fields/BillListingFilter";
import BillPaidFilter from "../fields/BillPaidFilter";
import useTranslator from "../../../hooks/useTranslator";
import ColdStorageFilter from "../fields/ColdStorageFilter";
import CleaningModuleFilter from "../fields/CleaningModuleFilter";
import UnloadingFilter from "../fields/UnloadingFilter";
import RejectedLogFilter from "../fields/RejectedLogFilter";
import BrokerageRefrigerationFilter from "../fields/BrokerageRefrigerationFilter";
import WashingAreaFilter from "../fields/WashingAreaFilter";
import BrokerageMaterialEnteredFilter from "../fields/BrokerageMaterialEnteredFilter";
import RipeningRoomByIdFilter from "../fields/RipeningRoomByIdFilter";
import SortingFilter from "../fields/SortingFilter";
import OvenFilter from "../fields/OvenFilter";
import GasConsumptionFilter from "../fields/GasConsumptionFilter";
import HumidLogsFilter from "../fields/HumidLogsFilter";
import ToastedLogsFilter from "../fields/ToastedLogsFilter";


const TableFilter = ({
  title,
  totalRecordsTitle,
  buttons,
  count,
  showCount = true,
  tab,
  activeTab,
  onTabChange,
  showFilter = {},
  showFilterButton,
  filterModule = null,
  date, // Pass filter callback
  filters = {},
  filterProps = {},
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const { _t } = useTranslator();
  const hasActiveFilters = Object.values(filters || {}).some((value) => {
    if (Array.isArray(value)) {
      return value.length > 0;
    }

    if (typeof value === "string") {
      const trimmedValue = value.trim().toLowerCase();
      return trimmedValue !== "" && trimmedValue !== "all";
    }

    return value !== null && value !== undefined && value !== false;
  });

  const renderFilter = () => {
    switch (filterModule) {
      case "employee":
        return (
          <EmployeeFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
          />
        );
      case "staffAttendance":
        return (
          <StaffAttendanceFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
            filters={filters}
          />
        );
      case "staffAttendanceReport":
        return (
          <StaffAttendanceReportFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
            filters={filters}
          />
        );
      case "billListing":
        return (
          <BillListingFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
          />
        );
      case "billPaidListing":
        return (
          <BillPaidFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
          />
        );
      case "coldStorage":
        return (
          <ColdStorageFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
            filters={filters}
          />
        );
      case "cleaning_filter":
        return (
          <CleaningModuleFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
          />
        );
      case "date_filter":
        return (
          <CleaningModuleFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
          />
        );
      case "unloading_filter":
        return (
          <UnloadingFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
            filters={filters}
          />
        );
      case "rejection_log":
        return (
          <RejectedLogFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
            filters={filters}
          />
        );
      case "brokerage_refrigeration_filter":
        return (
          <BrokerageRefrigerationFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
            filters={filters}
          />
        );
      case "washing-area":
        return (
          <WashingAreaFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
            filters={filters}
          />
        );
      case "brokerage-material-entered-fltr":
        return (
          <BrokerageMaterialEnteredFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
          />
        );
      case "ripening-room-by-id":
        return (
          <RipeningRoomByIdFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
            filters={filters}
            {...filterProps}
          />
        );
      case "sorting-filter":
        return (
          <SortingFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
            filters={filters}
          />
        );
      case "oven-filter":
        return (
          <OvenFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
            filters={filters}
          />
        );
      case "gas-consumption-filter":
        return (
          <GasConsumptionFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
            filters={filters}
          />
        );
      case "humid-logs-filter":
        return (
          <HumidLogsFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
            filters={filters}
          />
        );
      case "toasted-logs-filter":
        return (
          <ToastedLogsFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
            filters={filters}
          />
        );
      case "green-room-logs-filter":
        return (
          <HumidLogsFilter
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
            filters={filters}
          />
        );
      default:
        return (
          <FilterComponent
            onApplyFilter={showFilter}
            date={date}
            onClose={() => setShowDropdown(false)}
          />
        );
    }
  };

  return (
    <div className="filter_head d-flex gap-2 align-items-center mb-3">
      {title && (
        <h3 className="flex-grow-1 mb-0">
          {title} {_t("data", "Data")}
        </h3>
      )}
      <ul className="d-flex align-items-center gap-3 mb-0">
        {showCount && (
          <li className="d-flex align-items-center gap-3 supplier_count">

            {totalRecordsTitle != ""
              ? `${totalRecordsTitle}`
              : `${_t('number_of', 'Number of')} ${title}`
            }
            <span className="cmn_btn grey_btn d-flex align-items-center justify-content-center">
              {count || "0"}
            </span>
          </li>
        )}
        {showFilterButton && (
          <li>
            <Dropdown
              className="custom_filter"
              show={showDropdown}
              onToggle={(isOpen) => setShowDropdown(isOpen)}
            >
              <Dropdown.Toggle
                id="dropdown-basic"
                className={`cmn_btn grey_btn ${hasActiveFilters ? "filter_active" : ""}`}
                size="small"
                variant="unset"
              >
                {Filtersvg} {_t("filters", "Filters")}
                {hasActiveFilters && <span className="filter_active_dot" />}
              </Dropdown.Toggle>

              <Dropdown.Menu className="mb-5">{renderFilter()}</Dropdown.Menu>
            </Dropdown>
          </li>
        )}

        {buttons?.map((button, index) => (
          <li key={index}>
            <Button
              size="small"
              icon={button.icon || null}
              label={button.label}
              className={button.className || "default_btn_class"}
              onClick={button.onClick}
            />
          </li>
        ))}
        {tab && (
          <div className="custom_navs">
            <Tab.Container id="left-tabs-example" defaultActiveKey="cheeks">
              <Nav variant="pills" className="flex justify-content-end">
                <Nav.Item>
                  <Nav.Link
                    eventKey="cheeks"
                    active={activeTab === "cheeks"}
                    onClick={() => onTabChange("cheeks")}
                  >
                    {_t("cheeks", "Cheeks")}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="strips"
                    active={activeTab === "strips"}
                    onClick={() => onTabChange("strips")}
                  >
                    {_t("strips", "Strips")}
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="cheeks"></Tab.Pane>
                <Tab.Pane eventKey="strips"></Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        )}
      </ul>
    </div>
  );
};

export default TableFilter;
